<template>
  <div id="app">
    <img alt="Six String Trivia" src="logo.png" class="logo">
    <div id="container">
      <div class="col-2-3">
        <h1>Mark Boyd's Acoustic Music Trivia | {{statuses[status]}} <span v-if="customstatus != ''">{{customstatus}}</span></h1>
        <div id="videobox">
          <!--iframe src="https://www.youtube.com/embed/live_stream?channel=UCQstuuWUDj2GaXt6wQVlvng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe-->
          <div class="fb-video" data-href="https://www.facebook.com/markboydmusic/videos/2623485614595520/" data-show-text="true" data-width=""></div>
        </div>
        <p class="tips">Tips appreciated but not required. <a href="http://paypal.me/markboydmusic" target="_blank">Click here to leave Mark a tip!</a></p>
      </div>
      <div class="col-1-3 logincol">
        <div v-if="status == 'loading'" class="ok">
          <p>Doing complicated technical stuff...</p>
        </div>
        <div v-else-if="status == 'default'" class="ok">
          <p>Sorry, Mark's not here.</p>
          <p>Try back later.</p>
        </div>
        <div v-else-if="status == 'stopped'" class="ok">
          <p>Thank you for playing.</p>
        </div>
        <div v-else class="ok">
          <div class="name"><span v-if="this.name != ''">Hi, {{name}} ({{email}})!</span></div>
          <div v-if="!started">
            <LoginForm @setContactInfo="setContactInfo" />
          </div>
          <div v-else>
            <GameForm :name="name" :email="email" :status="status" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LoginForm from './components/LoginForm.vue'
import GameForm from './components/GameForm.vue'

export default {
  name: 'App',
  components: {
    LoginForm,
    GameForm
  },
  data: function () {
    return {
      started: false,
      name: '',
      email: '',
      statusUpdate: null,
      status: 'loading',
      customstatus: '',
      statuses: {
        'loading': 'Loading...',
        'ready':   'Getting Ready!',
        'started': 'Rock & Roll! The Game Is On!',
        'stopped': 'Game Over.',
        'default': 'Inactive. Come Back Later.'
      }
    }
  },
  methods: {
    setContactInfo: function(info) {
      this.name = info.name;
      this.email = info.email;
      this.startGame();
    },
    startGame: function() {
      this.started = true;
    },
    heartbeat: function() {
      this.statusUpdate = setInterval(() => {
        axios.post('https://sixstringtrivia.com:3000/', {statusping: 'statusping'})
        .then((response) => {
          this.status = response.data.status;
          this.customstatus = response.data.customstatus;
        })
        .catch((err) => {
          this.status = err;
        });
      }, 5000);
    }
  },
  created: function() {
    this.heartbeat();
  }
}
</script>

<style lang="scss">
html,body { margin: 0; padding: 0; }
html { box-sizing: border-box; }
*, *:after, *:before { box-sizing: inherit; }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 1300px;
  margin: 0 auto;
  h1 { 
    font-size: 1em; 
    margin: -10px auto 10px; 
    span { float: right; color: #a00; font-size: 1.1em; }
  }
}
.name { margin: -10px 0; height: 20px; }
.logo { 
  display: block; 
  margin: 0 auto; 
  width: 100%; 
  max-width: 500px;
}
#container { width: 100%; }
.col-1-2, .col-1-3, .col-2-3 {
  padding: 10px;
  width: 100%;
}
@media screen and (min-width: 767px) {
  #container { display: flex; }
  .col-1-2, .col-1-3, .col-2-3 { flex: 1 1 auto; }
  .col-1-2 { width: 50%; }
  .col-1-3 { width: 33.33%; }
  .col-2-3 { width: 66.66%; }
  .logincol {
    max-width: 400px;
    flex: 0 1 auto;
  }
}

#videobox {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  background: #000;
  position: relative;
  iframe { width: 100%; height: 100%; position: absolute; top: 0; left: 0; }
}
.tips { 
  font-weight: bold; 
  a {
    display: inline-block;
    padding: 10px;
    color: #fff;
    text-decoration: none;
    background: #000;

  }

}
</style>
